var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.7,
    height: 16,
    viewBox: "0 0 19.7 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter-brands",
    d: "M17.675,52.07c.013.175.013.35.013.525A11.409,11.409,0,0,1,6.2,64.082,11.41,11.41,0,0,1,0,62.27a8.351,8.351,0,0,0,.975.05,8.086,8.086,0,0,0,5.013-1.725,4.045,4.045,0,0,1-3.775-2.8,5.091,5.091,0,0,0,.763.062,4.27,4.27,0,0,0,1.062-.137A4.038,4.038,0,0,1,.8,53.757v-.05a4.066,4.066,0,0,0,1.825.512,4.044,4.044,0,0,1-1.25-5.4A11.476,11.476,0,0,0,9.7,53.045a4.558,4.558,0,0,1-.1-.925,4.041,4.041,0,0,1,6.988-2.763,7.949,7.949,0,0,0,2.563-.975,4.027,4.027,0,0,1-1.775,2.225,8.094,8.094,0,0,0,2.325-.625,8.679,8.679,0,0,1-2.025,2.087Z",
    transform: "translate(0 -48.082)",
    fill: "#2f77b6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBrands);
export default __webpack_public_path__ + "static/media/twitter-brands.6eb7b3b22eee448832127cc8b0965d07.svg";
export { ForwardRef as ReactComponent };